<template>
  <div id="app">
    <div v-if="!started" id="introCard">
      <h1>Everything A Cycle: {{ iteration }}</h1>
      <p v-if="subtitle">{{ subtitle }}</p>
      <button @click="start">Start</button>
    </div>
    <div v-else id="canvas"></div>
    <a href="https://awakening.systems" target="_blank">
      <img id="logo" src="@/assets/icon.png" />
    </a>
  </div>
</template>

<script>
var _ = require("lodash");
var p5 = require("p5");
import { patch } from "@/audio/synth.js";
import { composition } from "@/audio/composition-config.js";
import { patch2 } from "@/audio/synth-2.js";
import { composition2 } from "@/audio/composition-config-2.js";

export default {
  data() {
    return {
      started: false,
      iteration: "01",
      subtitle: "The Same Recurring Dream",
    };
  },
  methods: {
    async start() {
      this.started = true;
      await Tone.start();
      await Tone.Transport.start();
      Tone.Transport.bpm.value = 60;
      this.scheduleAudio();
      this.scheduleAudio2();
      this.visualStart();
    },
    scheduleAudio() {
      let lastNote = _.last(composition.events);
      let endOfLoop = lastNote.rawTime + lastNote.rawDuration;
      let rest = Tone.Time(composition.rest).toSeconds();
      let interval = endOfLoop + rest;

      let part = new Tone.Part((time, event) => {
        patch.synth.triggerAttackRelease(
          event.note,
          event.duration,
          time,
          event.velocity
        );

        Tone.Draw.schedule(() => {}, time);

        Tone.Draw.schedule(() => {}, time + event.rawDuration);
      }, composition.events);
      part.loopEnd = interval;
      part.loop = true;
      part.start();
    },
    scheduleAudio2() {
      let lastNote = _.last(composition2.events);
      let endOfLoop = lastNote.rawTime + lastNote.rawDuration;
      let rest = Tone.Time(composition2.rest).toSeconds();
      let interval = endOfLoop + rest;

      let part = new Tone.Part((time, event) => {
        patch2.synth.triggerAttackRelease(
          event.note,
          event.duration,
          time,
          event.velocity
        );

        Tone.Draw.schedule(() => {
        }, time);

        Tone.Draw.schedule(() => {}, time + event.rawDuration);
      }, composition.events);
      part.loopEnd = interval;
      part.loop = true;
      part.start();
    },
    visualStart() {
      const s = (sketch) => {
        let shapes = [];
        let rotation = 0;

        sketch.setup = function() {
          sketch.angleMode(sketch.DEGREES);
          sketch.createCanvas(sketch.windowWidth, sketch.windowHeight);

          for (let i = 0; i < 5; i++) {
            let shapePos = new DottedLine(20 * i, 20 * i, 8, 6, 250, 20);
            shapes.push(shapePos);
            let shapeNeg = new DottedLine(-20 * i, -20 * i, 8, 6, 250, 20);
            shapes.push(shapeNeg);
          }
        };

        sketch.draw = function() {
          sketch.background(191, 171, 204, 15);
          shapes.forEach((shape) => {
            shape.render();
          });
          rotation += 0.5;
        };

        sketch.windowResized = function() {
          sketch.resizeCanvas(sketch.windowWidth, sketch.windowHeight)
        }

        class DottedLineShape {
          constuctor() {
            this.active = true;
            this.fillColor = "#ffa6d9";
            this.strokeColor = "#ffa6d9";
          }

          render(xPos, yPos, shapeSize) {
            if (sketch.random() > 0.99) {
              this.active = !this.active;
            }
            sketch.push();
            if (this.active) {
              sketch.fill("#ffa6d9");
            } else {
              sketch.noFill();
            }
            sketch.stroke("#ffa6d9");
            sketch.circle(xPos, yPos, shapeSize);
            sketch.pop();
          }
        }

        class DottedLine {
          constructor(
            xOffset,
            yOffset,
            numSteps,
            numLines,
            shapeSize,
            dotSize
          ) {
            this.xOffset = xOffset;
            this.yOffset = yOffset;
            this.shapeWidth = shapeSize;
            this.shapeHeight = shapeSize;
            this.steps = numSteps;
            this.stepDistance = this.shapeHeight / this.steps;
            this.centerOffset = this.stepDistance;
            this.lines = numLines;
            this.angle = 360 / this.lines;
            this.dotSize = dotSize;
            this.dotsArray = [];

            for (let i = 0; i < this.steps; i++) {
              let newShape = new DottedLineShape(this.dotSize);
              this.dotsArray.push(newShape);
            }
          }

          render() {
            sketch.push();
            sketch.translate(
              sketch.windowWidth / 2 + this.xOffset,
              sketch.windowHeight / 2 + this.yOffset
            );
            sketch.rotate(rotation);
            for (let i = 0; i < this.lines; i++) {
              this.dotsArray.forEach((dot, index) => {
                let x = 0;
                let y = index * this.stepDistance + this.centerOffset;
                let size = this.dotSize;
                dot.render(x, y, size);
              });
              sketch.rotate(this.angle);
            }
            sketch.pop();
          }
        }
      };

      let sketch = new p5(s, document.getElementById("canvas"));
    },
  },
};
</script>

<style>
@font-face {
  font-family: "BebasNeue";
  src: local("BebasNeue"), url(fonts/Bebas_Neue/BebasNeue-Regular.ttf);
}

@font-face {
  font-family: "RobotoSlab";
  src: local("RobotoSlab"), url(fonts/Roboto_Slab/static/RobotoSlab-Light.ttf);
}

#logo {
  opacity: 0.5;
  height: 60px;
  width: 60px;
  position: absolute;
  bottom: 10px;
  right: 10px;
}

#logo:hover {
  opacity: 1;
}

html {
  background: #B9A6C7;
  color: #1a3644;
}

#introCard {
  text-align: center;
}

h1 {
  margin-top: 40px;
  font-family: "BebasNeue", cursive;
  font-size: 44px;
}

p {
  font-family: "RobotoSlab", serif;
  text-transform: lowercase;
}

button {
  color: #dbdbdb;
  background: #6b2e63;
  border: #6b2e63;
  cursor: pointer;
  margin-top: 80px;
  height: 40px;
  width: 120px;
  text-transform: uppercase;
  font-size: 12px;
  font-family: "RobotoSlab";
  font-weight: 200;
}

button:hover {
  background: #a14595;
}
</style>
